<template>
  <v-container grid-list-xl class="pa-0">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <v-card
          class="px-0 mb-10 elevation-0"
          style="margin-top:150px; padding-top:60px; z-index:0"
          v-if="$vuetify.breakpoint.mdAndUp"
        >
          <v-card-text class="py-0">
            <v-row align="center" justify="center">
              <v-col
                cols="12"
                sm="5"
                md="5"
                lg="5"
                xl="5"
                class="text-center px-5 my-0 pa-0"
                style="position:relative;"
              >
                <v-card
                  class="pa-5 mb-0 mt-5 rounded-lg"
                  style="position:absolute;top:-242px;z-index:1
                  webkit-box-shadow: 0px 0px 7px 5px rgba(51, 51, 51, 0.178);"
                >
                  <p class="font-weight-bold primary--text mb-3 mt-3" style="font-size:30px;">
                    Hi, <span class="orange--text">{{ current_user.name }}</span>
                  </p>
                  <p style="word-break: break-word;">
                    Selamat Datang di Sistem eLearning <b>Program Sekolah Penggerak</b>, Silakan pilih instansi Anda
                  </p>
                  <v-text-field
                    outlined
                    class="mt-2 mx-4"
                    dense
                    autofocus
                    v-model="textSearch"
                    placeholder="Cari Instansi"
                    hint
                    clearable
                    append-icon="mdi-magnify"
                    @click:append="pencarian(textSearch)"
                    @keyup.enter="pencarian(textSearch)"
                    @click:clear="hapusPencarian()"
                    persistent-hint
                  ></v-text-field>
                </v-card>
              </v-col>
            </v-row>
            <v-row row class="py-0">
              <v-col cols="12"> <div class="pt-2"></div> </v-col>
              <v-col cols="12" sm="6" md="3" lg="4" xl="4" v-for="item in items" :key="item.id">
                <BlockCard
                  :item="item"
                  :title="item.nama"
                  :height="185"
                  :logo="item.logo"
                  :cover="item.cover"
                  color="primary"
                  @pilih="pilihInstansi(item)"
                  to
                />
              </v-col>
            </v-row>
            <v-row wrap class="pb-0" v-if="page && page.last_page > 1">
              <v-col cols="5" sm="2" md="2" lg="2" class="text-left" align="center" justify="center">
                <p class="caption font-weight-bold">{{ page.total }} &nbsp;Instansi</p>
              </v-col>
              <v-col cols="1" sm="8" md="8" lg="8" v-if="$vuetify.breakpoint.smAndUp" class="text-center">
                <v-pagination
                  v-if="page.total"
                  :key="page_key"
                  v-model="current_page"
                  :length="page.last_page"
                  :total-visible="7"
                  @input="change"
                ></v-pagination>
              </v-col>
              <v-col cols="6" sm="2" md="2" lg="2" v-if="page.from" class="text-right">
                <p class="caption font-weight-bold">{{ page.from }} - {{ page.to }} dari {{ page.total }}</p>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions></v-card-actions>
        </v-card>
        <!-- -------------mobile -->
        <v-card class="px-0 mb-10 elevation-0" style="z-index:0" v-if="$vuetify.breakpoint.smAndDown">
          <v-card-text class="py-0">
            <v-row align="center" justify="center">
              <v-col cols="12" sm="5" md="5" lg="5" xl="5" class="text-center px-5 my-0 pa-0">
                <v-card flat class="pa-5 mb-0 mt-5 rounded-lg">
                  <p class="font-weight-bold primary--text mb-3 mt-3" style="font-size:30px;">
                    Hi, <span class="orange--text">{{ current_user.name }}</span>
                  </p>
                  <p style="word-break: break-word;">
                    Selamat Datang di Sistem eLearning <b>Program Sekolah Penggerak</b>, Silakan pilih instansi Anda
                  </p>
                  <v-text-field
                    outlined
                    class="mt-2 mx-4"
                    dense
                    autofocus
                    v-model="textSearch"
                    placeholder="Cari Sekolah"
                    hint
                    clearable
                    append-icon="mdi-magnify"
                    @click:append="pencarian(textSearch)"
                    @keyup.enter="pencarian(textSearch)"
                    @click:clear="hapusPencarian()"
                    persistent-hint
                  ></v-text-field>
                </v-card>
              </v-col>
            </v-row>
            <v-row row class="py-0">
              <v-col cols="12" sm="6" md="3" lg="3" xl="4" v-for="item in items" :key="item.id">
                <BlockCard
                  :item="item"
                  :title="item.nama"
                  :height="185"
                  :logo="item.logo"
                  :cover="item.cover"
                  color="primary"
                  @pilih="pilihInstansi(item)"
                  to
                />
              </v-col>
            </v-row>

            <v-row wrap class="pb-0" v-if="page && page.last_page > 1">
              <v-col cols="5" sm="2" md="2" lg="2" class="text-left" align="center" justify="center">
                <p class="caption font-weight-bold">{{ page.total }} &nbsp;Instansi</p>
              </v-col>

              <v-col cols="6" sm="2" md="2" lg="2" v-if="page.from" class="text-right">
                <p class="caption font-weight-bold">{{ page.from }} - {{ page.to }} dari {{ page.total }}</p>
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="2" v-if="$vuetify.breakpoint.smAndDown" class="text-center">
                <v-pagination
                  v-if="page.total"
                  :key="page_key"
                  v-model="current_page"
                  :length="page.last_page"
                  :total-visible="7"
                  @input="change"
                ></v-pagination>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions></v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BlockCard from "@/components/BlockCard";
import Form from "../components/Form";

export default {
  components: {
    BlockCard,
    Form
  },
  data() {
    return {
      instansi: {},
      items: [],
      current_page: 1,
      hsidebar: false,
      page: null,
      cp: 1,
      dialog: true,
      textSearch: "",
      paging: 6,
      page_key: 0
    };
  },
  activated() {
    this.dialog = true;
  },
  mounted() {
    this.current_page = 1;
    this.load(this.current_page);
  },
  methods: {
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    pencarian(s) {
      this.textSearch = s;
      this.cp = 1;
      this.current_page = 1;
      this.load(1);
    },
    hapusPencarian() {
      this.textSearch = null;
      this.load(1);
    },

    load(current_page) {
      var paging = this.$vuetify.breakpoint.lgAndUp ? 8 : 6;
      return this.$store
        .dispatch("instansi/get", { page: current_page, pagination: paging, s: this.textSearch })
        .then(res => {
          this.page = res.data;
          this.items = res.data;

          if (res.data.length == 1 && !this.current_user.is_super_admin) {
            this.pilihInstansi(res.data[0]);
          }
        })
        .catch(e => e);
    },

    change() {
      this.load(this.current_page);
    },
    pilihInstansi(item) {
      return this.$store
        .dispatch("instansi/switchInstansi", item.id)
        .then(() => {
          this.$store.commit("main/setLDrawer", true);
          return this.$router.push({
            name: "beranda",
            params: { instansi_id: item.id }
          });
        })
        .catch(e => e);
    }
  },
  watch: {
    page(n) {
      if (n) {
        this.current_page = n.current_page;
        this.jump_page = n.current_page;
        this.page_key = Math.random();
      }
    },
    hsidebar(n) {
      this.$store.commit("main/setHsidebar", n);
    }
  },
  computed: {
    is_disabled() {
      return this.CONFIG.SINGKRONISASI == "true" ? true : false;
    }
  }
};
</script>

<style></style>
